import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { EditForwardForm } from "../form/EditForwardForm";
import { ControlcenterMelcoControlCenterModelsForwardLinkListItem } from "melco-shared-logic";

// const Right = styled(Space)`
//   display: flex;
//   flex-direction: column
//   align-items: flex-end;
// `;

type EditForwardDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  ForwardLinkDetails: ControlcenterMelcoControlCenterModelsForwardLinkListItem;
};

export const EditForwardDrawer: React.FC<EditForwardDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  ForwardLinkDetails,
}) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer();

  return (
    <Drawer
      title={t("url_forward.actions.edit.title")}
      placement="right"
      width={500}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: "32px" }}
    >
      {isDrawerOpen && (
        <EditForwardForm
          referenceDrawer={referenceDrawer}
          onCloseDrawer={setDrawerOpen}
          ForwardLinkDetails={ForwardLinkDetails}
        />
      )}
    </Drawer>
  );
};
